// MOCA (materiali a contatto con alimenti): modulo aggiuntivo "moca".

// Riga dell'etichetta B2B: identica a moca_label_text in backend/label_pdf.py.
export const mocaLabelText = (moca) =>
  `${moca?.item_name || "Imballaggio"} (${(moca?.material_label || "Altro").toLowerCase()}) – Lotto ${moca?.lot_ref || "—"}`;

export const CERTIFICATE_STATUS = {
  presente: { status: "verde", label: "Certificazione presente" },
  da_riverificare: { status: "giallo", label: "Certificazione da riverificare" },
  mancante: { status: "rosso", label: "Certificazione mancante" },
};
